const PERMISSION_KEY= "company:bc_economic_sector";
const PAGE_URL = {
    B_C_ECONOMIC_SECTOR_PAGE: "/admin/company/bc-economic-sector"
}

export {PERMISSION_KEY, PAGE_URL}

